import Holidays from '../assets/data/bank-holidays.json'

import { subMinutes, isSameDay, format, getDay } from 'date-fns'

export default {
  data () {
    return {
      holidays: Holidays.dates,
      openingTimes: [
        {
          name: 'Sunday',
          start: [10, 0],
          end: [14, 0],
          nextDays: 2,
          isClosed: true
        },
        {
          name: 'Monday',
          start: [9, 0],
          end: [17, 30],
          nextDays: 2,
          isClosed: false
        },
        {
          name: 'Tuesday',
          start: [9, 0],
          end: [17, 30],
          nextDays: 2,
          isClosed: false
        },
        {
          name: 'Wednesday',
          start: [9, 0],
          end: [17, 30],
          nextDays: 2,
          isClosed: false
        },
        {
          name: 'Thursday',
          start: [9, 0],
          end: [17, 30],
          nextDays: 2,
          isClosed: false
        },
        {
          name: 'Friday',
          start: [9, 0],
          end: [17, 30],
          nextDays: 3,
          isClosed: false
        },
        {
          name: 'Saturday',
          start: [10, 0],
          end: [16, 0],
          nextDays: 2,
          isClosed: true
        }
      ]
    }
  },
  methods: {
    isOfficeOpen (date = new Date()) {
      if (this.openingTimes[getDay(date)].isClosed) return false
      if (this.isOutOfHours(date)) return false
      if (this.isBankHoliday(date)) return false
      return true
    },

    isBankHoliday (date) {
      return this.holidays.includes(format(date, 'yyyy-MM-dd'))
    },

    isBeforeStartOfDay (date) {
      const dayNumber = getDay(date)
      const startTime = this.openingTimes[dayNumber].start

      const startOfDay = new Date().setHours(startTime[0], startTime[0], 0, 0)
      if (isSameDay(date, new Date())) {
        return date < startOfDay
      }
    },

    isOutOfHours (date) {
      const isBeforeStartOfDay = this.isBeforeStartOfDay(date)

      // Last time you can schedule a same-day call, 0h 0min before closing time
      const dayNumber = getDay(date)
      const endTime = this.openingTimes[dayNumber].end

      const closingTime = new Date().setHours(endTime[0], endTime[1], 0, 0)
      const cutoff = subMinutes(closingTime, 0)

      if (isSameDay(date, new Date())) {
        return isBeforeStartOfDay || date > cutoff
      }
    }
  }
}
